import { observer } from "mobx-react-lite";

import { ClaimsListCard } from "../claims/components/ClaimsListCard.tsx";
import { AccErrorLogsFilter } from "./AccErrorLogsFilter.tsx";

const AccErrorLogsPage = observer(() => {
  return (
    <ClaimsListCard heading="ACC error logs">
      <AccErrorLogsFilter />
    </ClaimsListCard>
  );
});

// ⚠ It should be exported as default since it is used for React.lazy
// eslint-disable-next-line import/no-default-export
export default AccErrorLogsPage;
